// PerformanceCard.tsx

import { PerformanceCardConfig } from '../../config/data';
import PerformanceItem from './PerformanceItem';

interface PerformanceCardProps {
    config: PerformanceCardConfig;
}

const PerformanceCard: React.FC<PerformanceCardProps> = ({ config }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 w-full min-w-[300px]">
            {/* Header */}
            <div className="flex justify-between items-center px-6 pt-4 pb-2 border-b border-gray-100">
                <h3 className="text-lg font-semibold text-gray-700">{config.title}</h3>
                <span className="text-sm font-medium text-gray-500">Targets Achieved</span>
            </div>

            {/* List Container - Simulating Scrollbar appearance with fixed height and padding */}
            <div className="p-4 max-h-[300px] overflow-y-auto relative custom-scrollbar">
                {config.data.map((bde) => (
                    <PerformanceItem
                        key={bde.id}
                        bde={bde}
                        isHighPerforming={config.isHighPerforming}
                    />
                ))}

            </div>
        </div>
    );
};

export default PerformanceCard;